import React from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';

import { MobileHelpLink } from 'components/no-auth/help/styles';
import NotAuthBasePage from 'components/no-auth/NotAuthBasePage';

import { toggleChat } from 'actions/chatAction';

import { getLangCountryPrefix } from 'helpers/utils';

import { CommonPagePromo } from '../../components/no-auth/common/CommonPagePromo';
import { LightDiskButton } from '../../components/no-auth/common/fromAuth/LightDiskButton/LightDiskButton';
import { LightHeaderPanel } from '../../components/no-auth/common/fromAuth/LightHeaderPanel/LightHeaderPanel';
import { LightIcon } from '../../components/no-auth/common/fromAuth/LightIcon/LightIcon';
import { LightText } from '../../components/no-auth/common/fromAuth/LightText/LightText';
import ZendeskHelpMobileSearch from '../../components/no-auth/help/ZendeskHelpMobileSearch';
import { useGetQueryParams } from '../../components/no-auth/utils';
import { AUTH_SEND_MAIN_LINK } from '../../constants/UrlConstants';

const ZendeskHelpMobileSectionPage = (props) => {
    const { platform } = useGetQueryParams();
    let { sectionId } = useParams();
    const sectionIdNumber = Number(sectionId);
    const section = props.sections?.find((s) => s.id === sectionIdNumber);

    const url = `${getLangCountryPrefix(props.lang, props.country)}/help-mobile`;

    const articles = props.articles?.map((article) => {
        return (
            <MobileHelpLink key={article.id} href={`${url}/category/${props.category.id}/section/${sectionId}/article/${article.id}`}>
                <LightText>{article.name}</LightText>
                <LightIcon name="chevron-right" color={'purple'} leftIndent={'16px'} />
            </MobileHelpLink>
        );
    });

    return (
        <CommonPagePromo
            backUrl={`${url}/category/${props.category.id}`}
            type={'tagA'}
            buttonId={'helpPageBackButton'}
            rightHeaderComponent={<LightDiskButton type={'tagA'} href={AUTH_SEND_MAIN_LINK} iconName={'cross'} id={'helpPageCloseButton'} />}
        >
            <LightHeaderPanel title={section?.name} />
            <ZendeskHelpMobileSearch isMobilePlatform={platform === 'ios' || platform === 'android'} />
            {articles}
        </CommonPagePromo>
    );
};

const mapStateToProps = ({ extra }) => ({
    category: extra?.zendeskHelpData?.category,
    sections: extra?.zendeskHelpData?.sections,
    articles: extra?.zendeskHelpData?.articles,
    lang: extra.noAuthFooter?.language?.lang,
    country: extra.noAuthFooter?.language?.country,
});

export default connect(mapStateToProps, { toggleChat })(NotAuthBasePage(ZendeskHelpMobileSectionPage));
